import { Button, type ButtonProps } from '@monksflow/monks-ui';
import { Check } from 'lucide-react';
import clsx from 'clsx';
import { microInteraction } from '../MicroInteractions';
import { useTranslation } from 'react-i18next';

export interface ApprovalActionButtonProps extends Omit<
  ButtonProps,
  'children' | 'size' | 'variant'
> {
  approved: boolean;
}

export function ApprovalActionButton({ approved, className, ...props }: ApprovalActionButtonProps) {
  const { t } = useTranslation('common');

  return (
    <Button
      size="sm"
      variant="outline"
      className={clsx(
        'h-9 gap-1',
        microInteraction.approveAction,
        approved
          ? 'border-0 bg-positive text-positive-foreground hover:bg-positive/80 hover:text-positive-foreground'
          : 'font-normal hover:bg-positive/80 hover:text-positive-foreground',
        className,
      )}
      {...props}
    >
      {approved && (
        <Check
          data-testid="approval-action-icon"
          className={clsx('size-5', microInteraction.approveIcon)}
        />
      )}
      {approved ? t('ui.approvalActionButton.approved') : t('ui.approvalActionButton.approve')}
    </Button>
  );
}

ApprovalActionButton.displayName = 'ApprovalActionButton';
